import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">Terms of Service</CardTitle>
        </CardHeader>
        <CardContent className="prose max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Fintecy's services, you agree to be bound by these Terms of
            Service and all applicable laws and regulations. If you do not agree with any of these
            terms, you are prohibited from using or accessing our services.
          </p>

          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily use our services for personal, non-commercial
            purposes. This is the grant of a license, not a transfer of title, and under this
            license you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to decompile or reverse engineer any software</li>
            <li>Remove any copyright or other proprietary notations</li>
            <li>Transfer the materials to another person</li>
          </ul>

          <h2>3. User Account</h2>
          <p>
            To access certain features of our services, you must create an account. You are
            responsible for maintaining the confidentiality of your account information and for all
            activities that occur under your account.
          </p>

          <h2>4. Financial Services</h2>
          <p>
            Our services may include financial tools and information. We do not provide financial
            advice, and you should consult with qualified professionals before making financial
            decisions.
          </p>

          <h2>5. Disclaimer</h2>
          <p>
            The materials on our services are provided on an 'as is' basis. We make no warranties,
            expressed or implied, and hereby disclaim and negate all other warranties including,
            without limitation, implied warranties or conditions of merchantability, fitness for a
            particular purpose, or non-infringement of intellectual property or other violation of
            rights.
          </p>

          <h2>6. Limitations</h2>
          <p>
            In no event shall Fintecy or its suppliers be liable for any damages (including, without
            limitation, damages for loss of data or profit, or due to business interruption) arising
            out of the use or inability to use our services.
          </p>

          <h2>7. Revisions and Errata</h2>
          <p>
            The materials appearing on our services could include technical, typographical, or
            photographic errors. We do not warrant that any of the materials are accurate, complete,
            or current.
          </p>

          <h2>8. Links</h2>
          <p>
            We have not reviewed all of the sites linked to our services and are not responsible for
            the contents of any such linked site. The inclusion of any link does not imply
            endorsement by us of the site.
          </p>

          <h2>9. Modifications</h2>
          <p>
            We may revise these terms of service at any time without notice. By using our services,
            you agree to be bound by the current version of these terms of service.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws and
            you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>

          <p className="text-muted-foreground mt-8 text-sm">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default TermsOfService;
